module.exports = __webpack_public_path__ + "static/media/kubernetes.b5f19b2b.png";